import { Button, DateTimeRangePicker, Pane } from '@leverege/ui-elements';
import classnames from 'classnames';
import { useCallback, useMemo } from 'react';
import { FilterSourceModel, FilterSourcesModel } from '@leverege/molten/filters';
import RsrcFilterModel from "../filter/RsrcFilterModel.js";
import S from './FilterByCreatedAt.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Filter(props) {
  const {
    value,
    onChange
  } = props;
  let nValue = value;
  if (typeof value === 'object' && value != null) {
    nValue = {
      start: value?.start ? new Date(value.start) : null,
      end: value?.end ? new Date(value.end) : null
    };
  }
  return /*#__PURE__*/_jsx(DateTimeRangePicker, {
    variant: "rsrcFilterByCreatedAt",
    className: S.dtr,
    popupContainerClassName: S.createdAtPopup,
    value: nValue,
    onChange: onChange
  });
}
export default {
  id: 'rsrc.list.createdAtFilter',
  name: 'CreatedAt Filter',
  matches: {
    client: ['GroupScreen'],
    use: 'sortFilterBarRight',
    objectType: 'rsrc'
  },
  layout: {
    sort: 'aaaa'
  },
  handles: () => true,
  customComponent: FilterByCreatedAt
};
function FilterByCreatedAt({
  context
}) {
  const {
    filters,
    onFilterChange
  } = context;
  const filter = useMemo(() => {
    return FilterSourcesModel.getSource(filters, 'filterBar') || FilterSourceModel.create();
  }, [filters]);
  const rsrcFilterModel = useMemo(() => {
    return FilterSourceModel.getMetadata(filter)?.filter;
  }, [filter]);
  const value = useMemo(() => {
    return RsrcFilterModel.getFilter(rsrcFilterModel || RsrcFilterModel.create(), 'createdAt');
  }, [rsrcFilterModel]);
  const onChange = useCallback(({
    value: sValue
  }) => {
    const nRsrcFilterModel = RsrcFilterModel.setFilter(rsrcFilterModel || RsrcFilterModel.create(), 'createdAt', sValue);
    let nFilter = FilterSourceModel.setMetadata(filter, {
      ...FilterSourceModel.getMetadata(filter),
      filter: nRsrcFilterModel
    });
    nFilter = FilterSourceModel.setFilter(nFilter, RsrcFilterModel.toRsrcFilter(nRsrcFilterModel));
    onFilterChange({
      data: 'filterBar',
      value: nFilter
    });
  }, [filter, onFilterChange, rsrcFilterModel]);
  return /*#__PURE__*/_jsxs(Pane, {
    className: S.container,
    layout: "flex:row",
    children: [/*#__PURE__*/_jsx(Button, {
      className: classnames(S.clear, S.way, S.more, S.specific),
      variant: "rsrcFilterByCreatedAt|tertiaryIconic",
      onClick: onChange,
      icon: "fa fa-times",
      disabled: !value
    }), /*#__PURE__*/_jsx(Filter, {
      value: value,
      onChange: onChange
    })]
  });
}